import React from 'react';
import styled from 'styled-components';
import {getOutlet, useOutlet} from 'reconnect.js';
import {Form, Input, Button, Result, Space, message, Alert} from 'antd';
import Config from '../../../data.json';
import * as AppActions from '../../AppActions';
import qs from 'query-string';
import * as AsyncStorage from 'rev.sdk.js/Utils/AsyncStorage';

const LoginRequired = (props) => {
  const [user] = useOutlet('user');
  const {location} = props;
  const params = qs.parse(location.search) || {};
  const [orgId, setOrgId] = React.useState(params?.org_id);
  const [organization, setOrganization] = React.useState();
  const [refreshing, setRefreshing] = React.useState(true);

  React.useEffect(() => {
    (async () => {
      if (!params?.org_id) {
        setOrgId(await AsyncStorage.getItem('org_id'));
      }
    })();
  }, [params?.org_id]);

  React.useEffect(() => {
    (async () => {
      if (orgId) {
        try {
          let resp = await AppActions.fetchOrganization(orgId);
          setOrganization(resp);
        } catch (e) {
          console.log(e);
        }
      }
      setRefreshing(false);
    })();
  }, [orgId]);

  const onFinish = async (values) => {
    AppActions.setLoading(true);
    try {
      if (!orgId) {
        AppActions.setLoading(false);
        return message.error('無法取得組織編號');
      }

      await AppActions.login({
        org: orgId,
        username: values.username,
        password: values.password,
      });
    } catch (e) {
      console.log(e);
      message.error('發生錯誤');
    }
    AppActions.setLoading(false);
  };
  const onFinishFailed = async (e) => {
    console.log('error', e);
    message.error('發生錯誤');
  };

  return !user ? (
    <Wrapper>
      <Form
        name="basic"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off">
        <Form.Item
          label="帳號"
          name="username"
          rules={[{required: true, message: '請輸入帳號'}]}>
          <Input />
        </Form.Item>

        <Form.Item
          label="密碼"
          name="password"
          rules={[{required: true, message: '請輸入密碼'}]}>
          <Input.Password />
        </Form.Item>

        {}

        {refreshing ? (
          <Alert type="info" style={{marginBottom: 20}} message="載入中..." />
        ) : !orgId ? (
          <Alert
            type="error"
            style={{marginBottom: 20}}
            message="無法取得組織編號"
          />
        ) : organization ? (
          <Alert
            type="success"
            style={{marginBottom: 20}}
            message={`歡迎來到 ${organization.name} 登入入口`}
          />
        ) : !organization ? (
          <Alert
            type="error"
            style={{marginBottom: 20}}
            message="無法取得組織資料"
          />
        ) : null}

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            登入
          </Button>
        </Form.Item>
      </Form>
    </Wrapper>
  ) : (
    props.children
  );
};

const Wrapper = styled.div`
  min-height: 100vh;
  padding-top: var(--topNavBarHeight);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export default LoginRequired;
